import React from 'react'
import Shop from './shop'

function ShopMain() {
    return(
        <Shop/>
    );
}

export default ShopMain;